// Port of api/fuel/app/classes/insights/worth/games.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'games',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['games'],
	run: function(type, owner, userIndex, detail, filter) {
		var limit = detail ? 1000 : 5
		var mode = (filter && filter.games) ? filter.games : 'most'
		var games = []
		var worthField = ((mode === 'highest' || mode === 'lowest')
			? 'COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0) / c.collection_plays'
			: 'COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0)')

		var raw = Util.queryFast(
			'SELECT g.game_id AS g, ' + worthField + ' AS w, c.collection_rating AS r, c.collection_plays AS p' +
			' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
			' WHERE c.user_id = ' + owner.get_id() +
			' AND c.collection_own = 1' +
			' AND g.game_worth_value > 0' +
			((mode === 'highest' || mode === 'lowest') ? ' AND c.collection_plays > 0' : '') +
			' ORDER BY w ' + ((mode === 'most' || mode === 'highest') ? 'DESC' : 'ASC') +
			' LIMIT 0, ' + limit
		)

		for (var i = 0; i < raw.length; i++) {
			var item = raw[i]
			var gameId = parseInt(item.g, 10)
			this._references.games.push(gameId)

			if (detail) {
				games.push({
					id: gameId,
					worth: Math.round((parseFloat(item.w) || 0) * 100) / 100,
					plays: parseInt(item.p, 10) || 0
				})
			} else {
				games.push({
					g: gameId,
					w: Math.round((parseFloat(item.w) || 0) * 100) / 100,
					r: parseFloat(item.r) || 0,
					p: parseInt(item.p, 10) || 0
				})
			}
		}

		return {
			games: games
		}
	}
})
